export class TimeoutError extends Error {
	constructor(message = 'Timeout') {
		super(message)
		this.name = 'TimeoutError'
	}
}

export const withTimeoutError = <T>(
	callback: Promise<T>,
	timeout: number,
): Promise<T> =>
	new Promise<T>((resolve, reject) => {
		const timer = setTimeout(() => {
			reject(new TimeoutError())
		}, timeout)
		callback.then(
			(value) => {
				clearTimeout(timer)
				resolve(value)
			},
			(error) => {
				clearTimeout(timer)
				reject(error)
			},
		)
	})
